module.exports = "/images/gn.svg?16fe901c862a70d08a73da1857de5e7c";